import { Nav, Navbar, Image, Row, Col } from "react-bootstrap";
import { NavLink } from "react-router-dom";
// import {COLORS} from '../config/constants'
import logo from "../assets/logo.png";

const NavBar = () => {
  return (
    <Navbar variant="light" style={{ backgroundColor: "#fff0e6" }}>
      <Row className="w-100 mx-auto">
        <Col xs={12} className="text-center">
          <Navbar.Brand>
            <Nav.Link as={NavLink} to="/">
              <Image
                src={logo}
                className="d-inline-block "
                height="55"
                alt="Akoad logo"
              />
            </Nav.Link>
          </Navbar.Brand>
        </Col>
        <Col xs={12} className="d-flex justify-content-center">
          <Nav className="h5 text-center"> 
            <Nav.Link as={NavLink} exact={true} to="/">
              قائمة المتاجر
            </Nav.Link>   
            <Nav.Link as={NavLink} to="/contact-us">
              تواصل معنا
            </Nav.Link>
            
          </Nav>
        </Col>
      </Row>
    </Navbar>
  );
};

export default NavBar;
